import type { AppProps } from 'next/app';
import Head from 'next/head';
import localFont from 'next/font/local';
import '@rainbow-me/rainbowkit/styles.css';
import '@/styles/globals.css';

import { Providers } from '@/components/providers';
import { Layout } from '@/components/Layout';

const googleSans = localFont({
  src: '../public/GoogleSansFlex.ttf',
  variable: '--font-google-sans-flex',
  display: 'swap',
  weight: '100 900',
});

function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>ZKPool</title>
        <link rel="icon" href="/favicon.png" />
        <meta
          name="description"
          content="ZKPool wallet connections powered by RainbowKit"
        />
      </Head>
      <div className={`${googleSans.variable} font-(--font-google-sans-flex)`}>
        <Providers>
          <Layout>
            <Component {...pageProps} />
          </Layout>
        </Providers>
      </div>
    </>
  );
}

export default App;
